import { DecimalScale } from '@globaleris/ui.library'
import { EnumEstadoRemit, EnumTipoDocumento } from '../../api'
import { EnumRegulatoryReportState } from '../../api/oData/requests/enumRegulatoryReportState'
import { EnumTipoOperacion } from '../../api/oData/enums/enumTipoOperacion'
import { enumKeyToValue } from '../../helpers'
import { formatLocaleNumber } from '../../helpers/numberHelper'
import { getActiveBalanceZone, getActiveCompany } from '../../redux'
import {
  remitReportLngModel,
  remitReportOperationModel,
  remitReportPositionModel,
  remitStorageReportModel,
  remitRequestModel,
  remitTableResponseModel,
  remitLngResponseModel,
  remitStorageResponseModel,
  regulatoryReportDownloadCard,
  reportFilesByGroupsRequestModel
} from './regulatoryReports.Model'
import { getGlobalActionsConfiguration } from './regulatoryReports.service'
import { EnumFileStateWithDispatch } from '../../api/Pioneer/enums/enumFileStateWithDispatch'
import { EnumEstadoRemitCustom } from '../../api/oData/enums/enumEstadoRemitCustom'
import i18n from '../../i18n'
import moment from 'moment'

//#Region Remit Table
export const remitTableOperationReportsListItemsMapper = (
  items: remitTableResponseModel[]
): remitReportOperationModel[] => {
  return items && items.map(remitTableOperationReportsListItemMapper)
}

export const remitTableOperationReportsListItemMapper = (
  item: remitTableResponseModel
): remitReportOperationModel => {
  return (
    item && {
      tradeCode: item.tradeCode,
      counterpart: item.counterpart,
      signDate: item.signDate,
      date: item.date,
      type: enumKeyToValue(EnumTipoOperacion, item.type),
      logisticElement: item.logisticElementCode + ' - ' + item.logisticElementDescription,
      state:
        enumKeyToValue(EnumEstadoRemitCustom, item.state) === EnumEstadoRemitCustom.Lg_generado_sct1
          ? EnumRegulatoryReportState.Enviado
          : EnumRegulatoryReportState.Pendiente
    }
  )
}

export const formRequestRemit = (
  startDate: Date,
  endDate: Date,
  types: any[],
  idElemLog: number | undefined = undefined
): remitRequestModel => {
  const formatDate = (date: Date): string => {
    const y = date.getFullYear()
    const m = (date.getMonth() + 1).toString().padStart(2, '0')
    const d = date.getDate().toString().padStart(2, '0')
    return `${y}-${m}-${d}`
  }

  return {
    operationTypes: types,
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
    idElemLog: idElemLog,
    balanceZone: getActiveBalanceZone()?.id,
    company: getActiveCompany()?.id
  }
}

export const formRequestReportFilesByGroups = (
  groupsDocuments: any[]
): reportFilesByGroupsRequestModel => {
  let activeCompany = getActiveCompany()?.id
  let activeBalanceZone = getActiveBalanceZone()?.id
  return {
    groupsDocuments: groupsDocuments,
    balanceZone: activeBalanceZone,
    company: activeCompany
  }
}

export const remitTablePositionReportsListItemsMapper = (
  items: remitTableResponseModel[]
): remitReportPositionModel[] => {
  return items && items.map(remitTablePositionReportsListItemMapper)
}

export const remitTablePositionReportsListItemMapper = (
  item: remitTableResponseModel
): remitReportPositionModel => {
  return (
    item && {
      tradeCode: item.tradeCode,
      counterpart: item.counterpart,
      signDate: item.signDate,
      startDate: item.initDate,
      endDate: item.endDate,
      type: enumKeyToValue(EnumTipoOperacion, item.type),
      logisticElement: `${item.logisticElementCode || ''}`.concat(
        ' - ',
        item.logisticElementDescription
      ),
      state:
        enumKeyToValue(EnumEstadoRemitCustom, item.state) ===
          EnumEstadoRemitCustom.Lg_generado_sct1 ||
        enumKeyToValue(EnumEstadoRemitCustom, item.state) ===
          EnumEstadoRemitCustom.Lg_generado_nsct2
          ? EnumRegulatoryReportState.Enviado
          : enumKeyToValue(EnumEstadoRemitCustom, item.state) === EnumEstadoRemitCustom.Pending
            ? EnumRegulatoryReportState.Pendiente
            : EnumRegulatoryReportState.Operaciones_pendientes
    }
  )
}

//#endregion

//#region Remit Storage

export const remitStorageReportsListItemsMapper = (
  items: remitStorageResponseModel[]
): remitStorageReportModel[] => {
  return items && items.map(remitStorageReportsListItemMapper)
}

export const remitStorageReportsListItemMapper = (
  item: remitStorageResponseModel
): remitStorageReportModel => {
  return (
    item && {
      date: item.date,
      logisticElement: item.logisticElementCode + ' - ' + item.logisticElementDescription,
      state:
        enumKeyToValue(EnumEstadoRemit, item.state) === EnumEstadoRemit.Lg_generado_spa
          ? EnumRegulatoryReportState.Enviado
          : EnumRegulatoryReportState.Pendiente
    }
  )
}

//#endregion

//#region Remit LNG

export const remitLngReportsListItemsMapper = (
  items: remitLngResponseModel[]
): remitReportLngModel[] => {
  return items && items.map(remitLngReportsListItemMapper)
}

export const remitLngReportsListItemMapper = (item: remitLngResponseModel): remitReportLngModel => {
  return (
    item && {
      date: item.shipDate,
      code: item.shipCode,
      sequenceNumber: item.sequenceNumber,
      type: enumKeyToValue(EnumTipoOperacion, item.type),
      destination: item.destination,
      ship: item.ship,
      state:
        enumKeyToValue(EnumEstadoRemit, item.state) === EnumEstadoRemit.Lng_activity ||
        enumKeyToValue(EnumEstadoRemit, item.state) === EnumEstadoRemit.Lng_planned
          ? EnumRegulatoryReportState.Enviado
          : EnumRegulatoryReportState.Pendiente
    }
  )
}

//#endregion

//#region Remit Documents

export const remitReportFilesListItemsMapper = (
  reportFiles: regulatoryReportDownloadCard[]
): regulatoryReportDownloadCard[] => {
  return (
    reportFiles &&
    reportFiles
      .map(reportFile => remitReportFilesListItemMapper(reportFile))
      .filter(x => x !== undefined)
  )
}

export const remitReportFilesListItemMapper = (
  reportFile: regulatoryReportDownloadCard
): regulatoryReportDownloadCard => {
  const docTypeName = i18n.t(
    `enums:DocumentTypes.${enumKeyToValue(EnumTipoDocumento, reportFile.documentType)}`
  )
  return (
    reportFile && {
      fileId: reportFile.fileId,
      fileName: reportFile.fileName,
      fileDate: reportFile.fileDate,
      fileRrm: reportFile.fileRrm,
      fileState: enumKeyToValue(EnumFileStateWithDispatch, reportFile.fileState),
      fileUrl: reportFile.fileUrl,
      urlLog: reportFile.urlLog,
      documentType: enumKeyToValue(EnumTipoDocumento, reportFile.documentType), //docTypeName,
      canDownload: reportFile.canDownload,
      actionsConfiguration: getGlobalActionsConfiguration()
    }
  )
}

//#endregion
